/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { formatPriceMejorado } from '../../../../_mexablock/helpers';

type Props = {
  data: any;
};

const Offers: React.FC<Props> = ({ data }) => {
  return (
    <>
      <div className="card card card-flush h-xl-100 border border-3">
        <div className="card-body">
          <div className="d-flex align-items-center h-45px">
            <h2 className="fs-2" style={{ color: '#F68626' }}>
              {data.name}
            </h2>
          </div>

          <div>
            <span className="fs-5 fw-bolder d-block text-hover-primary">
              {`${data.gb} GB de Datos`}
            </span>
          </div>
          <span className="fw-semibold fs-6">
            {`${formatPriceMejorado(data.price, 'es-MX', 'MXN')}`}
          </span>
          <span className="fw-semibold fs-6">
            {` / ${data.commercial_time} días`}
          </span>
          <div className="separator separator-dashed mb-5 mt-5" />

          <div className="fw-semibold fs-5 mt-1 text-gray-600">
            {data.commercial_time != 365 ? (
              <i
                className="fas fa-thumbs-up me-3"
                style={{ color: '#F68626' }}
              />
            ) : (
              <i className="fas fa-thumbs-up me-3" />
            )}
            Redes ilimitadas
          </div>
          <div className="fw-semibold fs-5 mt-1 text-gray-600">
            {data.share_internet ? (
              <i className="fas fa-wifi me-3" style={{ color: '#F68626' }} />
            ) : (
              <i className="fas fa-wifi me-3" />
            )}
            Hotspot
          </div>
          <div className=" fw-semibold fs-5  mt-1 text-gray-600">
            <i className="fas fa-phone-alt me-3" style={{ color: '#F68626' }} />
            Min ilimitados
          </div>
          <div className=" fw-semibold fs-5 mt-1 text-gray-600">
            <i className="fas fa-sms me-3" style={{ color: '#F68626' }} />
            SMS ilimitados
          </div>
        </div>
      </div>
    </>
  );
};

export { Offers };
